import http from "../http";
import Service from "../../Service";

/**
 * @type ResupplyService
 */
export default class ResupplyService extends Service {

    resupply(params = {}, config = {}) {

        return http.get(
            `/clients/requests/resupply`,
            {
                headers: this.getHeaders(),
                params,
                ...config,
            }
        );
    }


}